var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuotationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9230",
    "data-name": "Group 9230",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.038,
    height: 16.307,
    viewBox: "0 0 19.038 16.307",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3129",
    "data-name": "Rectangle 3129",
    width: 19.038,
    height: 16.307,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9229",
    "data-name": "Group 9229",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M137.449,133.228H132.44a.75.75,0,0,1-.572-.21.666.666,0,0,1,.049-1,.846.846,0,0,1,.47-.144.806.806,0,0,1,.085,0q4.988,0,9.975,0a1.218,1.218,0,0,1,.284.033.648.648,0,0,1,.5.582.678.678,0,0,1-.428.68.958.958,0,0,1-.353.062h-5",
    transform: "translate(-124.195 -124.388)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M137.453,25.228h-5a.856.856,0,0,1-.458-.112.674.674,0,0,1-.078-1.1.847.847,0,0,1,.479-.149.833.833,0,0,1,.085,0q4.988,0,9.975,0a1.117,1.117,0,0,1,.334.049.624.624,0,0,1,.439.538.635.635,0,0,1-.28.627.745.745,0,0,1-.459.143c-.354,0-.709,0-1.063,0h-3.977",
    transform: "translate(-124.202 -22.515)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M137.447,241.229h-5.009a.749.749,0,0,1-.572-.21.665.665,0,0,1,.051-1,.852.852,0,0,1,.47-.144.822.822,0,0,1,.085,0q4.988,0,9.975,0a1.218,1.218,0,0,1,.284.033.647.647,0,0,1,.5.583.679.679,0,0,1-.429.679.964.964,0,0,1-.353.062h-5",
    transform: "translate(-124.194 -226.263)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M2.2,4.053a.664.664,0,0,1-.394-.13c-.1-.072-.187-.152-.277-.231-.189-.166-.376-.333-.565-.5C.914,3.146.858,3.1.807,3.053c-.178-.167-.355-.337-.533-.5a.683.683,0,0,1-.247-.466.629.629,0,0,1,.331-.62.614.614,0,0,1,.709.042c.154.112.3.235.446.361.192.168.377.344.565.517.085.079.1.078.178-.008.383-.413.764-.828,1.15-1.238C3.694.83,3.991.53,4.284.226A.656.656,0,0,1,5.417.5a.607.607,0,0,1-.117.55c-.164.2-.34.4-.518.591-.561.6-1.126,1.2-1.689,1.8-.1.108-.2.219-.3.33a.789.789,0,0,1-.589.281",
    transform: "translate(-0.023 0)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M.674,109.377a.577.577,0,0,1,.379.136c.259.215.513.435.768.655.086.074.166.154.249.231.062.057.083.058.14,0s.134-.156.205-.23c.152-.159.309-.313.459-.473.285-.306.564-.618.85-.923.179-.191.368-.374.552-.561a.658.658,0,0,1,.473-.21.67.67,0,0,1,.644.506.608.608,0,0,1-.12.55c-.164.2-.34.4-.518.591-.561.6-1.126,1.2-1.689,1.8-.1.109-.2.22-.3.33a.784.784,0,0,1-.512.275.656.656,0,0,1-.462-.121c-.1-.072-.192-.156-.286-.237-.189-.165-.377-.333-.565-.5C.87,111.128.8,111.066.727,111c-.163-.152-.324-.307-.487-.459A.68.68,0,0,1,0,110.05a.662.662,0,0,1,.674-.673",
    transform: "translate(0 -101.874)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M5.418,217.134a.636.636,0,0,1-.192.468L3.1,219.875c-.1.109-.2.219-.3.33a.825.825,0,0,1-.4.261.669.669,0,0,1-.577-.1,3.23,3.23,0,0,1-.278-.23c-.192-.168-.382-.338-.572-.507-.072-.063-.144-.126-.214-.191-.161-.15-.319-.3-.48-.452a.679.679,0,0,1-.245-.467.63.63,0,0,1,.334-.619.612.612,0,0,1,.7.038c.158.113.308.239.454.367.192.168.377.344.565.517.082.075.1.076.171,0,.412-.444.822-.89,1.237-1.331.257-.274.524-.539.783-.811a.642.642,0,0,1,.438-.213.753.753,0,0,1,.28.045.676.676,0,0,1,.432.624",
    transform: "translate(-0.022 -204.184)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationIcon);
export default __webpack_public_path__ + "static/media/quotation-icon.0ea678fde0b500044b740641e3bd4819.svg";
export { ForwardRef as ReactComponent };